import { api } from "../convex/_generated/api";

/** Matches convex/checkInWithLocation — within this radius, use the BeReal photo flow. */
export const CHECKIN_DISTANCE_METERS = 40;

/**
 * Record a check-in without proximity validation and create a photo-less moment for recap/rating.
 */
export async function completeRemoteRecapCheckIn({
  convex,
  checkInWithLocation,
  createMoment,
  userId,
  userPrivyDid,
  restaurantId,
  latitude,
  longitude,
}) {
  const alreadyCheckedInToday = await convex.query(
    api.checkInWithLocation.hasCheckedInToday,
    { userId, restaurantId }
  );
  if (alreadyCheckedInToday === true) {
    return { ok: false, reason: "already_checked_in" };
  }

  const checkInResult = await checkInWithLocation({
    userId,
    restaurantId,
    latitude,
    longitude,
    awardPoints: false,
  });

  if (!checkInResult.success) {
    return {
      ok: false,
      reason: "check_in_failed",
      message: checkInResult.errorMessage,
      errorType: checkInResult.errorType,
    };
  }

  let momentId = null;
  if (userPrivyDid) {
    try {
      momentId = await createMoment({
        privyDid: userPrivyDid,
        restaurantId,
        visibility: "friends",
        checkedInAtLocation: false,
      });
    } catch (e) {
      console.error("Remote check-in: could not create moment for recap:", e);
    }
  }

  return { ok: true, momentId, checkInResult };
}
